import { logEvent } from 'firebase/analytics';
import { getFirebaseAnalytics } from './firebase';

function track(eventName: string, params?: Record<string, string | number | boolean>) {
  const analytics = getFirebaseAnalytics();
  if (!analytics) return;
  logEvent(analytics, eventName, params);
}

export function logPageView(path: string) {
  track('page_view', { page_path: path, page_title: document.title });
}

export function logLogin(method: 'email' | 'google' | 'microsoft' | 'passkey') {
  track('login', { method });
}

export function logLogout() {
  track('logout');
}

export function logOrderOpened(orderId: string) {
  track('order_opened', { order_id: orderId });
}

export function logTransactionOpened(transactionId: string) {
  track('transaction_opened', { transaction_id: transactionId });
}

export function logRefundOpened(refundId: string) {
  track('refund_opened', { refund_id: refundId });
}

export function logOpenInNewTab(entityType: 'order' | 'refund', entityId: string) {
  track('open_in_new_tab', { entity_type: entityType, entity_id: entityId });
}

export function logExportData(page: string, format: 'csv' | 'xlsx') {
  track('export_data', { page, format });
}

export function logFilterApplied(page: string, filterType: string) {
  track('filter_applied', { page, filter_type: filterType });
}
